<template>
  <PageSecondary>
    <template #title>Level Up Public</template>
    <h1 style="font-size: xx-large; font-weight: 900;">Детский сад</h1>
    <h5 style="font-size: small; font-weight: normal;">
      <span>Вечер четверга, 12 августа, 19:15—21:55</span>
      <br>
      <a href="https://yandex.ru/maps/org/lampa/182204523522" target="_blank">
        м. Семеновская
        <br>
        LAMPA Ткацкая 5с10
      </a>
      <br>
      <span>1500₽ (предоплата 600₽ на аренду помещения)</span>
    </h5>
    <img src="@/assets/kid8.png" style="max-width: 100%; padding: 8px 0 0; box-sizing: border-box;">
    Люди восхищаются детьми за их открытость, жажду жить и смелость.
    <img src="@/assets/kid2.png" style="max-width: 100%; padding: 8px 0 0; box-sizing: border-box;">
    А бывает взрослые просто не могут это переварить.
    <img src="@/assets/kid10.png" style="max-width: 100%; padding: 8px 0 0; box-sizing: border-box;">
    Бывает мы виним взрослых за то, что они ведут себя как капризные и глупые дети.
    <img src="@/assets/kid11.png" style="max-width: 100%; padding: 8px 0 0; box-sizing: border-box;">
    Давай найдём детей внутри себя и внутри других и наладим с ними связь!
    <img src="@/assets/kid4.png" style="max-width: 100%; padding: 8px 0 0; box-sizing: border-box;">
    Ты вдруг можешь обнаружить потерянных и разочарованных детей.
    <img src="@/assets/kid5.png" style="max-width: 100%; padding: 8px 0 0; box-sizing: border-box;">
    Но мы сможем придумать как наконец дать им безопасность и любовь.
    <img src="@/assets/kid6.png" style="max-width: 100%; padding: 8px 0 0; box-sizing: border-box;">
    Для кого, с кем и как? На встрече собираются:
    <ul style="">
      <li>Приятные, честные, открытые люди.</li>
      <li>Те, кто активно растёт как личность.</li>
    </ul>
    <img src="@/assets/kid9.png" style="max-width: 100%; padding: 8px 0 0; box-sizing: border-box;">
    Что мы делаем?
    <ul style="">
    <li>Мы смело говорим правду и внимательно слышим других.</li>
    <li>Вместе выбираем цель и идём к ней играя.</li>
    <li>Пьём горячий чай, зажигаем свечи, и делимся плюшками.</li>
    </ul>
    <img src="@/assets/kid13.png" style="max-width: 100%; padding: 8px 0 0; box-sizing: border-box;">
    На тренинге будет:
    <ul style="">
      <li>Разогрев ума и тела, расширение внимание</li>
      <li>Настройка каждого на общий вайб</li>
      <li>Подпитка ресурсом</li>
      <li>Исследование детского интереса</li>
      <li>Освобождение от блоков детского интереса</li>
      <li>Интеграция опыта и плавный выход обратно в жизнь</li>
    </ul>
    <img src="@/assets/kid12.png" style="max-width: 100%;">
    Твой ребёнок терпеливо ждёт
    <div style="font-style: italic; margin-top: 16px; color: red;">
      Условия
    </div>
    <div style="font-style: italic; margin-bottom: 256px; margin-top: 16px;">
      Встреча на 8 участников, осталось 3 места. Напиши <a href="https://t.me/kostiagp">Косте</a>, чтобы участвовать и скинь ему предоплату 600₽ на +7 977 423-59-42<br>
      * Поужинать за час до встречи. Чтоб 3 часа не сидели голодные и не пришли с набитым брюхом, потому что мы потрошим ваш внутренний мир (с)
    </div>
  </PageSecondary>
</template>

<script>
import PageSecondary from "@/components/PageSecondary";

export default {
  name: 'LevelUpPublic_2021_08_12',
  components: {PageSecondary},
  props: {
    secret: String,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
